import { buildHTMLReport } from '../../reports/buildHtmlReport.mjs';
import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
import API from '../../services/api.js';

import { useParams } from "react-router-dom";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import LoadingPopup from "../misc/Loading.js";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from 'recharts';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {styled} from "@mui/material/styles";
import {Link} from 'react-router-dom'
import { X, Download, FileCode2, CheckCircle2, XCircle, AlertTriangle, Layers, ChevronDown } from "lucide-react";
import { useMemo } from "react";

import RedTeamFrameworkCard from './RedTeamFrameworkCard';

import { useRef } from "react";
import Logo from '../../assets/reportlogo.png';

const severityOrder = {
  "Critical": 1,
  "High": 2,
  "Medium": 3,
  "Low": 4,
};

export default function Details() {


  const reportRef = useRef(null);
  const exportMenuRef = useRef(null);


  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen); 

  const handlesidebar = async (item) => {
    console.log("items", item);
  }

  const { id } = useParams();
  sessionStorage.setItem('id', id);
  const selectedApp = sessionStorage.getItem('selectedApp');
  const payload = useMemo(() => ({ selected_app: selectedApp }), [selectedApp]);

  const [data, setData] = useState(null);
  const [vulndata, setVulnData] = useState([]);
  const [falsePositiveRows, setFalsePositiveRows] = useState([]);
  const [detectorNames, setDetectorNames] = useState({});
  const getFilteredPromptRows = (rows) => {
    if (!rows) return [];
    const arr = Array.isArray(rows) ? rows : [rows];
    return arr.filter(row => {
      const status = (row?.status ?? row?.Status ?? '').toString().toLowerCase();
      const isFalsePositive = row?.is_false_positive ?? row?.isFalsePositive ?? row?.false_positive ?? false;
      const failureReason = row?.failureReason ?? row?.failure_reason ?? row?.failure_reason_code;
      const hasFailStatus = status.includes('fail') || status.includes('failed');
      const hasFailReason = failureReason === 1 || failureReason === '1';
      return (hasFailStatus || hasFailReason) && !Boolean(isFalsePositive);
    });
  };
  const getFalsePositiveRows = (rows) => {
    if (!rows) return [];
    const arr = Array.isArray(rows) ? rows : [rows];
    return arr.filter(row => {
      const isFalsePositive = row?.is_false_positive ?? row?.isFalsePositive ?? row?.false_positive ?? false;
      return Boolean(isFalsePositive);
    });
  };
  const evalID = data?.evalId
  const [loading, setLoading] = useState(false);
  const [, setError] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const modifiedId = id ? id.replace(/:/g, "_") : "";
  sessionStorage.setItem('filename', modifiedId);

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event) => {
      if (exportMenuRef.current && !exportMenuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    const handleKey = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKey);
    };
  }, [isOpen]);

  
  // Safe download utility function
  const downloadFile = (blob, filename) => {
    try {
      // Create object URL
      const url = URL.createObjectURL(blob);
      
      // Create temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.style.display = 'none';
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      // Fallback: open in new tab
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      URL.revokeObjectURL(url);
    }
  };

  // Function to convert your React component data to HTML and download it
  const downloadHTMLReport = async (data, vulndata) => {
    
    // Convert Logo image to base64
    let logoBase64 = '';
    try {
      const response = await fetch(Logo);
      const blob = await response.blob();
      logoBase64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Failed to load logo:', error);
      logoBase64 = 'data:image/png;base64,'; // fallback
    }
    
    const htmlContent = buildHTMLReport(data, vulndata, logoBase64, detectorNames);

    // Create and download the file using safe download function
    const blob = new Blob([htmlContent], { type: 'text/html' });
    downloadFile(blob, `llminate-report-${modifiedId}.html`);
  };

  

  const renderValue = (value) => {
    if (typeof value === "object" && value !== null) {
      return <pre className="whitespace-pre-wrap">{JSON.stringify(value, null, 2)}</pre>;
    }
    return value !== undefined && value !== null ? value.toString() : "N/A";
  };

  //console.log(modifiedId);

  useEffect(() => {
  const fetchAll = async () => {
    setLoading(true);
    setError("");

    try {
      const [detailsRes, vulnRes, detectorsRes] = await Promise.all([
        API.get(`${process.env.REACT_APP_DJANGO_API_URL}/reports/${modifiedId}.json/`, { params: payload }),
        API.get(`${process.env.REACT_APP_DJANGO_API_URL}/vulnerabilities/${modifiedId}.json/`, { params: payload }),
        API.get(`${process.env.REACT_APP_DJANGO_API_URL}/detectors/`),
      ]);

      setData(detailsRes.data);
      setDetectorNames(detectorsRes?.data?.data?.detector_names || {});

      // Handle vuln response format
      const raw = vulnRes.data?.results ?? vulnRes.data;
      setVulnData(getFilteredPromptRows(raw));
      setFalsePositiveRows(getFalsePositiveRows(raw));

    } catch (err) {
      setError("Failed to fetch data");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (modifiedId) {
    fetchAll();
  }
}, [modifiedId, payload]);

  const handleExport = async (statusFilter = "fail") => {
    try {
      setLoading(true);

      const response = await API.get(`${process.env.REACT_APP_DJANGO_API_URL}/export-csv/${modifiedId}.json/`, {
        responseType: 'blob',
        params: { ...payload, status: statusFilter },
      });

      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
      const suffixMap = { fail: "failed", pass: "passed", error: "errored", all: "all" };
      const suffix = suffixMap[statusFilter] || "failed";
      downloadFile(blob, `llminate-report_${modifiedId}_${suffix}.csv`);
    } catch (err) {
      setError("Failed to export file.");
      console.error("Export Error:", err);
    } finally {
      setLoading(false);
      setIsOpen(false);
    }
  };

  

  const severityColors = {
    critical: "#BC2B30", // bg-red-900
    high: "#ef4444",     // bg-red-500
    medium: "#f59e0b",   // bg-yellow-500
    low: "#22c55e",      // bg-green-500
  };
  
  const COLORS = ["#22c55e", "#ef4444", "#9ca3af"];

  const criticalCount = data?.severity_counts?.critical ?? 0;
  const highCount = data?.severity_counts?.high ?? 0;
  const mediumCount = data?.severity_counts?.medium ?? 0;
  const lowCount = data?.severity_counts?.low ?? 0;
  console.log("Data", data)

  const formattedData = [
    { label: 'critical', count: criticalCount, color: severityColors.critical },
    { label: 'high', count: highCount, color: severityColors.high },
    { label: 'medium', count: mediumCount, color: severityColors.medium },
    { label: 'low', count: lowCount, color: severityColors.low }
  ];

  const falsePositivesByType = useMemo(() => {
    const map = new Map();
    falsePositiveRows.forEach((row) => {
      const type = row?.type || "Unknown Type";
      const category = row?.category || "Unknown Category";
      if (!map.has(type)) {
        map.set(type, { type, category, count: 0 });
      }
      map.get(type).count += 1;
    });
    return Array.from(map.values()).sort((a, b) => b.count - a.count);
  }, [falsePositiveRows]);

  const DarkTableContainer = styled(TableContainer)(({ theme }) => ({
    backgroundColor: "#121212", // very dark shade (close to black)
    color: "#ffffff",
    border: "1px solid #3C3D37",
    borderRadius: "0.5rem"
    
  }));
  
  const DarkTableCell = styled(TableCell)(({ theme }) => ({
    color: "#ffffff",
    borderColor: "#1f1f1f", // slightly lighter than background
  }));
  
  const sortedVulnerabilities = ["critical", "high", "medium", "low"]
    .flatMap(severity => {
      const issues = data?.classified_results?.[severity] || [];
      return issues.map(issue => ({
        ...issue,
        severity: severity
      }));
    })
    .sort((a, b) => {
        const capA = a.severity.charAt(0).toUpperCase() + a.severity.slice(1);
        const capB = b.severity.charAt(0).toUpperCase() + b.severity.slice(1);
        return (severityOrder[capA] || 5) - (severityOrder[capB] || 5);
    });

  return (
    <div className="h-auto">
      {loading ? (
        <LoadingPopup isVisible={true}/>
      ) : (
        <LoadingPopup isVisible={false}/> 
      )
      }
      <div className='flex flex-col m-4'>
        <p className="text-3xl text-white font-bold m-3 ml-6">Scan Details</p>
        <div className="border border-2 border-[#232325] m-4"/>
        <p className='text-white text-xl font-semibold ml-7 m-4'>LLM Risk Assessment on: {data?.provider}</p>
        <div className="flex flex-row justify-between ">
          <div className="ml-8 space-y-2">
            <p className="text-white text-lg ml-7 flex">
              <span className="font-bold min-w-[200px]">Scanned on:</span>
              <span>{data?.time}</span>
            </p>
            <p className="text-white text-lg ml-7 flex">
              <span className="font-bold min-w-[200px]">Evaluation ID:</span>
              <span>{evalID}</span>
            </p>
            <p className="text-white text-lg ml-7 flex">
              <span className="font-bold min-w-[200px]">Business Criticality:</span>
              <span>{data?.criticality}</span>
            </p>
            <p className="text-white text-lg ml-7 flex">
              <span className="font-bold min-w-[200px]">Target:</span>
              <span>{data?.target}</span>
            </p>
          </div>

          <div ref={exportMenuRef} className="flex flex-col w-auto m-7 relative">
            <button
              className="flex w-52 items-center justify-between gap-2 px-4 py-2 rounded-xl border border-[#3B82F6] bg-[#0F172A] text-[#3B82F6] text-base hover:bg-[#1E293B] transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/40"
              onClick={() => setIsOpen(!isOpen)}
              aria-haspopup="menu"
              aria-expanded={isOpen}
            >
              <span className="flex items-center gap-2">
                <Download className="h-4 w-4" />
                <span>Export</span>
              </span>
              <ChevronDown
                className={`h-4 w-4 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
              />
            </button>

            {isOpen && (() => {
              const issuesCount = data?.issues_count || {};
              const totals = Object.values(issuesCount).reduce(
                (acc, sub) => {
                  Object.values(sub).forEach((v) => {
                    acc.pass += v?.Pass || 0;
                    acc.fail += v?.Fail || 0;
                    acc.error += v?.Error || 0;
                    acc.total += v?.Total || 0;
                  });
                  return acc;
                },
                { pass: 0, fail: 0, error: 0, total: 0 }
              );

              const csvItems = [
                {
                  key: "fail",
                  label: "Failed Cases",
                  desc: "Prompts that triggered a vulnerability",
                  count: totals.fail,
                  icon: XCircle,
                  iconClass: "text-[#ef4444]",
                  badgeClass: "bg-[#ef4444]/10 text-[#ef4444] border-[#ef4444]/30",
                },
                {
                  key: "pass",
                  label: "Passed Cases",
                  desc: "Prompts the model handled safely",
                  count: totals.pass,
                  icon: CheckCircle2,
                  iconClass: "text-[#22c55e]",
                  badgeClass: "bg-[#22c55e]/10 text-[#22c55e] border-[#22c55e]/30",
                },
                {
                  key: "error",
                  label: "Errored Cases",
                  desc: "Prompts that failed to evaluate",
                  count: totals.error,
                  icon: AlertTriangle,
                  iconClass: "text-[#f59e0b]",
                  badgeClass: "bg-[#f59e0b]/10 text-[#f59e0b] border-[#f59e0b]/30",
                },
                {
                  key: "all",
                  label: "All Test Cases",
                  desc: "Complete prompt-level results",
                  count: totals.total,
                  icon: Layers,
                  iconClass: "text-[#3B82F6]",
                  badgeClass: "bg-[#3B82F6]/10 text-[#3B82F6] border-[#3B82F6]/30",
                },
              ];

              return (
                <div
                  role="menu"
                  className="absolute top-12 right-0 w-52 bg-[#0F172A] border border-[#1E293B] shadow-2xl shadow-black/40 rounded-2xl z-50 overflow-hidden animate-in fade-in slide-in-from-top-1 duration-150"
                >
                  <div className="px-3 pt-3 pb-1">
                    <p className="text-[10px] tracking-wider uppercase text-slate-500 font-semibold">
                      Test Cases (CSV)
                    </p>
                  </div>

                  <div className="px-2 pb-2">
                    {csvItems.map((item) => {
                      const Icon = item.icon;
                      return (
                        <button
                          key={item.key}
                          role="menuitem"
                          onClick={() => handleExport(item.key)}
                          className="w-full flex items-center gap-2 px-2 py-2 rounded-lg hover:bg-[#1E293B] transition-colors duration-150 text-left"
                        >
                          <Icon className={`h-4 w-4 shrink-0 ${item.iconClass}`} />
                          <span className="text-white text-sm font-medium flex-1 min-w-0 truncate">{item.label}</span>
                          <span
                            className={`text-[10px] font-semibold px-1.5 py-0.5 rounded-full border ${item.badgeClass}`}
                          >
                            {item.count}
                          </span>
                        </button>
                      );
                    })}
                  </div>

                  <div className="border-t border-[#1E293B] mx-3" />

                  <div className="px-3 pt-3 pb-1">
                    <p className="text-[10px] tracking-wider uppercase text-slate-500 font-semibold">
                      Full Report
                    </p>
                  </div>

                  <div className="px-2 pb-2">
                    <button
                      role="menuitem"
                      onClick={() => {
                        setIsOpen(false);
                        downloadHTMLReport(data, vulndata);
                      }}
                      className="w-full flex items-center gap-2 px-2 py-2 rounded-lg hover:bg-[#1E293B] transition-colors duration-150 text-left"
                    >
                      <FileCode2 className="h-4 w-4 shrink-0 text-[#3B82F6]" />
                      <span className="text-white text-sm font-medium flex-1 min-w-0 truncate">HTML Report</span>
                    </button>
                  </div>
                </div>
              );
            })()}

          </div>
        </div>
      </div>

      {sortedVulnerabilities.length > 0 && (
      <div className="mt-[10vh]">
        <p className="text-3xl text-white font-bold m-12 ">
          Total Vulnerabilities
        </p>
        <div className="border-t border-[#232325] border-2 m-3 ml-12" />
        <div className="flex flex-row justify-evenly gap-8 m-8 ">
          {formattedData.map((item, index) => (
            <button className="cursor-pointer rounded-xl overflow-hidden " onClick={() => {handlesidebar(item)}}>
              <div key={index} className="flex flex-col items-center ">
                <div className="h-[20vh] flex">
                  <CircularProgressbar
                    value='100'
                    text={item.count.toString().padStart(2, '0')}
                    styles={buildStyles({
                      textSize: '24px',
                      pathColor: item.color,
                      textColor: '#fff',
                      trailColor: item.color,
                    })}
                  />
                </div>
                <p className="text-lg text-white mt-5 font-bold">{item.label.charAt(0).toUpperCase() + item.label.slice(1)}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
      )}

      <div className="flex flex-col mt-[7.5vh] m-12 bg-transparent">
        <p className="text-3xl font-bold text-white ml-6 m-3">Risk Categories</p>
        <div className="m-4 flex flex-col gap-6">
          {data?.issues_count &&
            Object.entries(data.issues_count).map(([category, subCategories]) => {
              const all = Object.values(subCategories);
              
              const passCount = all.reduce((sum, item) => sum + item.Pass, 0);
              const failCount = all.reduce((sum, item) => sum + item.Fail, 0);
              const errorCount = all.reduce((sum, item) => sum + item.Error, 0);
              const totalCount = all.reduce((sum, item) => sum + item.Total, 0);

              // Check if ALL detectors have no failed cases
              const allDetectorsPassed = Object.values(subCategories).every(
                subVal => (subVal.Fail || 0) === 0
              );

              const pieData = [
                { name: "Pass", value: passCount },
                { name: "Fail", value: failCount },
                { name: "Error", value: errorCount },
              ];

              return (
                <div key={category} className="flex flex-row bg-[#1e1e1e] text-white rounded-xl border border-[#3c3c3c]">
                  {/* Left Section */}
                  <div className="transform -rotate-90 h-auto w-36 text-center flex justify-center items-center">
                    <p className="text-lg text-white">{category}</p>
                  </div>
                  <div className="border border-[#3c3c3c]"/>

                  <div className="flex flex-col justify-center items-center w-[20%] border-r-1 border-[#3c3c3c] rounded-l-xl p-4">
                    {failCount > 0 ? (
                      <>
                        <p className="text-4xl font-bold">{failCount}/{totalCount}</p>
                        <p className="text-lg">Test Cases Failed</p>
                      </>
                    ) : (
                      <p className="text-lg">No Failed Cases</p>
                    )}
                  </div>

                  {/* Middle Section - Pie Chart + Legend */}
                  <div className="w-[40%] flex flex-col items-center justify-evenly p-4">
                    <div className="flex flex-row gap-12">
                      <ResponsiveContainer width={120} height={120}>
                        <PieChart>
                          <Pie
                            data={pieData}
                            dataKey="value"
                            innerRadius={40}
                            outerRadius={60}
                            paddingAngle={2}
                            stroke="none"
                          >
                            {pieData.map((_, index) => (
                              <Cell key={index} fill={COLORS[index % COLORS.length]} />
                            ))}
                          </Pie>
                        </PieChart>
                      </ResponsiveContainer>
                      <div className="mt-6 space-y-1 text-sm">
                        <div className="flex items-center gap-2">
                          <div className="w-3 h-3 rounded-full bg-[#22c55e]" />
                          <p>Pass - {passCount}</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="w-3 h-3 rounded-full bg-[#ef4444]" />
                          <p>Fail - {failCount}</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="w-3 h-3 rounded-full bg-[#9ca3af]" />
                          <p>Error - {errorCount}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Section - Subcategory List */}
                  <div className="w-[40%] border-l border-[#3c3c3c] p-4">
                    <p className="text-xl font-bold mb-6">Detectors</p>
                    
                    {allDetectorsPassed ? (
                      // Show single message when ALL detectors passed
                      <div className="flex justify-center items-center h-[100%]">
                          <span className="text-green-500 text-lg font-semibold">
                          No Failed Cases
                        </span>
                      </div>
                    ) : (
                      // Show individual detectors with failures
                      <ul className="text-sm space-y-2 mt-4">
                        {Object.entries(subCategories).map(([subName, subVal], idx) => {
                          // Only show detectors that have failures
                          if ((subVal.Fail || 0) > 0) {
                            return (
                              <li key={idx} className="flex justify-between">
                                <span className="text-md">{subName}</span>
                                <span className="bg-red-600/10 text-white px-4 py-1 border-red-700 border rounded-full text-lg">
                                  {subVal.Fail}
                                </span>
                              </li>
                            );
                          }
                          return null; // Don't render detectors with no failures
                        })}
                      </ul>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      {/* Framework Compliance Section */}
      {data?.framework_compliance && (
        <div className="mt-[7.5vh] m-12 flex flex-col">
          <p className="text-3xl font-bold text-white ml-6 m-3">
            Security Compliance
          </p>
          
          {/* Attack Success Rate Card */}
          <div className="bg-[#1e1e1e] border border-[#3c3c3c] rounded-xl p-6 mb-6">
            <p className="text-sm text-slate-400 mb-2">
              Compliance Rate
            </p>
            <p className="text-2xl font-bold text-white mb-4">
              {100 - data.framework_compliance.attackSuccessRate?.toFixed(1) || 0}%
            </p>
            {/* Progress bar */}
            <div className="h-2 w-full rounded-full overflow-hidden relative" style={{ background: 'rgba(0,0,0,0.3)' }}>
              {/* Full-width gradient always present underneath */}
              <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, #ef4444 0%, #f59e0b 50%, #22c55e 100%)' }} />
              {/* Dark overlay retreats left as compliance rises, revealing more green */}
              <div
                className="absolute top-0 right-0 bottom-0"
                style={{
                  left: `${Math.min(100, 100 - (data.framework_compliance.attackSuccessRate || 0))}%`,
                  background: '#1e1e1e',
                  transition: 'left 0.6s ease',
                }}
              />
            </div>
            <p className="text-xs text-slate-500 mt-2">
              {data.framework_compliance.failedTests || 0}/
              {data.framework_compliance.totalTests || 0} tests failed across{' '}
              {data.framework_compliance.total || 0} plugins
            </p>
          </div>

          {/* Framework Cards Grid */}
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3">
            {data.framework_compliance.frameworks?.map((framework, idx) => (
              <RedTeamFrameworkCard
                key={framework.name}
                framework={framework.name}
                isCompliant={framework.isCompliant}
                severity={framework.severity}
                nonCompliantPlugins={framework.nonCompliantPlugins || []}
                detectorNames={detectorNames}
                compliantCount={framework.compliantPlugins || 0}
                totalCount={framework.totalPlugins || 0}
                idx={idx}
              />
            ))}
          </div>
        </div>
      )}

      {sortedVulnerabilities.length > 0 && (
        <div className="m-12 flex flex-col mb-12">
          <p className="text-3xl font-bold text-white ml-3 mb-4 m-4">Vulnerabilities</p>

          <DarkTableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="vulnerability table">
              <TableHead>
                <TableRow>
                  <DarkTableCell><strong className="text-xl">Type</strong></DarkTableCell>
                  <DarkTableCell><strong className="text-xl">Description</strong></DarkTableCell>
                  <DarkTableCell><strong className="text-xl">Severity</strong></DarkTableCell>
                  <DarkTableCell><strong></strong></DarkTableCell>

                </TableRow>
              </TableHead>
              <TableBody>
                {sortedVulnerabilities.map((issue, index) => (
                  <TableRow key={index}>
                    <DarkTableCell>{issue.type}</DarkTableCell>
                    <DarkTableCell>{issue.description}</DarkTableCell>
                    <DarkTableCell>
                      <p className="h-10 justify-center items-center flex" style={{
                        backgroundColor: severityColors[issue.severity]/50, // Dark background like in second image
                        color: severityColors[issue.severity] || "white", // Text color matches the severity color
                        fontWeight: "bold",
                        textAlign: "center",
                        borderRadius: "1.25rem",
                        border: `2px solid ${severityColors[issue.severity] || "transparent"}`, // Colored border
                        minWidth: "80px",
                      }}>{issue.severity.charAt(0).toUpperCase() + issue.severity.slice(1).toLowerCase()}</p>


                    </DarkTableCell>
                    <DarkTableCell>
                      <Link
                        to={`/vulnerabilities/${modifiedId}?type_filter=${encodeURIComponent(issue.type)}`}
                        className="px-4 py-2 border border-blue-500 text-blue-400 rounded-full text-sm font-medium hover:bg-blue-500 hover:text-white transition duration-150 ease-in-out text-center"
                        style={{ textDecoration: "none", display: "inline-block" }}
                        onClick={() => {
                          sessionStorage.setItem("type_filter", issue.type);
                        }}
                      >
                        View More
                      </Link>
                 
                    </DarkTableCell>

                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </DarkTableContainer>
        </div>
      )}

      {falsePositiveRows.length > 0 && (
        <div className="mt-[6vh] m-12">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <p className="text-3xl text-white font-bold">False Positives</p>
              <span className="px-3 py-1 rounded-full border border-amber-500/40 text-amber-300 text-sm">
                {falsePositiveRows.length} total
              </span>
            </div>
            <Link
              to={`/vulnerabilities/${modifiedId}`}
              className="px-4 py-2 border border-amber-500 text-amber-300 rounded-full text-sm font-medium hover:bg-amber-500 hover:text-black transition duration-150 ease-in-out text-center"
              style={{ textDecoration: "none", display: "inline-block" }}
            >
              Review False Positives
            </Link>
          </div>
          <div className="border-t border-[#232325] border-2 m-3 ml-0" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
            {falsePositivesByType.map((item) => (
              <Link
                key={item.type}
                to={`/vulnerabilities/${modifiedId}?type_filter=${encodeURIComponent(item.type)}`}
                className="flex items-center justify-between bg-[#111111] border border-amber-500/20 rounded-2xl px-5 py-4 hover:border-amber-500/50 hover:bg-[#151515] transition"
                style={{ textDecoration: "none" }}
              >
                <div>
                  <div className="text-white font-semibold">{item.type}</div>
                  <div className="text-sm text-slate-400">{item.category}</div>
                </div>
                <div className="px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/40 text-amber-300 text-sm">
                  {item.count}
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}

      {/* report part */}
      {/* report part ------------------------------------------------------------------------------------------------------------*/}
      <div className='h-auto hidden bg-white overflow-scroll'>
        <style>{`
        .pdf-table {
          table-layout: fixed;
          width: 100%;
          border-collapse: collapse;
        }
        .pdf-table th, .pdf-table td {
          border: 1px solid #000;
          padding: 10px;
          vertical-align: top;
          word-wrap: break-word;
        }
        .pdf-row-block {
          page-break-inside: avoid;
          break-inside: avoid;
          margin-bottom: 100px;
          margin-top: 50px;
        }
        .col-category { width: 30%; }
        .col-type { width: 20%; }
        .col-severity { width: 28%; }
        .col-other { width: 50%; }

        @media print {
        body {
          background: white !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        * {
          box-shadow: none !important;
        }
        @media print {
          .page-break-start {
            page-break-before: always;
          }
        }

      }
  }
      `}</style>
        <div ref={reportRef} className="print-content">
          <div className='flex flex-row'>
            <img src={Logo} alt='logo' className='aspect-square h-[20vh]' />
            <div className='flex flex-col'>
              {/* <img src={Title} alt='Logo' className='w-auto h-[2vh] mr-3' /> */}
              <p className='text-[#0088FF] text-5xl font-bold mt-10'>LLMINATE</p>
              <p className='text-black text-3xl'>Comprehensive Report</p>
            </div>
          </div>

          <div className='flex flex-col m-4'>
            <p className="text-3xl text-black font-bold m-3 ml-6">Scan Details</p>
            {/* <img 
              src={KPMGlogo} 
              alt='KPMG' 
              className='h-full w-auto object-contain max-w-full ml-1' 
            /> */}
            <div className="border border-2 border-[#232325] m-4"/>
            <p className='text-black text-xl font-semibold ml-7 m-4'>LLM Risk Assessment on: {data?.provider}</p>
            <div className="flex flex-row justify-start ">
              <div className="ml-8">
                <p className="text-black text-lg ml-7 font-bold">Scanned on</p> 
                <p className="text-black text-lg ml-7 font-bold">Evaluation ID</p>
                <p className="text-black text-lg ml-7 font-bold">Description</p>
                <p className="text-black text-lg ml-7 font-bold">Target</p>
              </div>
              <div className="ml-8">
                <p className="text-black text-lg ml-7 ">{data?.time}</p> 
                <p className="text-black text-lg ml-7 ">{data?.data?.evalId}</p>
                <p className="text-black text-lg ml-7 ">{data?.data?.config?.description}</p>
                <p className="text-black text-lg ml-7 ">{data?.target}</p>
              </div>
            </div>
          </div>

          <div className="mt-[10vh] m-4">
            <p className="text-3xl text-black font-bold m-3 ml-6">
              Total Vulnerabilities
            </p>
            <div className="border border-[#232325] border-2 m-4" />
            
            <div className="flex flex-row justify-evenly gap-8 m-8 ">
              {formattedData.map((item, index) => (
                <div key={index} className="flex flex-col items-center ">
                  <div className="h-[20vh] flex">
                    <CircularProgressbar
                      value='100'
                      text={item.count.toString().padStart(2, '0')}
                      styles={buildStyles({
                        textSize: '24px',
                        pathColor: item.color,
                        textColor: '#000',
                        trailColor: item.color,
                      })}
                    />
                  </div>
                  <p className="text-lg text-black font-bold">{item.label.charAt(0).toUpperCase() + item.label.slice(1)}</p>
                </div>
              ))}
            </div>
          </div>
            <div className="flex flex-col mt-[7.5vh] m-8 bg-transparent">
              <p className="text-3xl font-bold text-black ml-6 mt-[5vh] m-3">Risk Categories</p>
              <div className="m-4 flex flex-col gap-6">
                {data?.issues_count &&
                  Object.entries(data.issues_count).map(([category, subCategories]) => {
                    const all = Object.values(subCategories);
      
                    const passCount = all.reduce((sum, item) => sum + item.Pass, 0);
                    const failCount = all.reduce((sum, item) => sum + item.Fail, 0);
                    const errorCount = all.reduce((sum, item) => sum + item.Error, 0);
                    const totalCount = all.reduce((sum, item) => sum + item.Total, 0);
      
                    const pieData = [
                      { name: "Pass", value: passCount },
                      { name: "Fail", value: failCount },
                      { name: "Error", value: errorCount },
                    ];
                    
                    if (failCount === 0) return null;
      
                    return (
                      <div key={category} className="flex flex-row h-auto bg-white text-black rounded-xl border border-[#3c3c3c]">
                        {/* Left Section */}
      
                        <div className="  h-auto w-[25%] text-center flex justify-center items-center">
                          <p className="text-sm text-black">{category}</p>
                        </div>
                        {/* <div className="border border-[#3c3c3c] border-1"/> */}
      
                        <div className="flex flex-col justify-center items-center w-[20%] border-r-1 border-l-1 border-[#3c3c3c]   p-4">
                          <p className="text-xl font-bold">{failCount}/{totalCount}</p>
                          <p className="text-sm text-center mt-3">Test Cases Failed</p>
                        </div>
      
                        {/* Middle Section - Pie Chart + Legend */}
                        <div className="w-[30%] flex flex-col items-center justify-center p-4">
                          {/* <p className="text-lg font-bold -mt-4">Vulnerabilities</p> */}
                          <div className="flex flex-col justify-center items-center gap-2 mt-4 mb-0">
                            <ResponsiveContainer width={120} height={120}>
                              <PieChart>
                                <Pie
                                  data={pieData}
                                  dataKey="value"
                                  innerRadius={25}
                                  outerRadius={40}
                                  paddingAngle={1}
                                  stroke="none"
                                >
                                  {pieData.map((_, index) => (
                                    <Cell key={index} fill={COLORS[index % COLORS.length]} />
                                  ))}
                                </Pie>
                              </PieChart>
                            </ResponsiveContainer>
                            <div className="mt-6 space-y-1 text-sm justify-center  flex flex-col ">
                              <div className="flex items-center gap-2">
                                <div className="w-3 h-3 rounded-full bg-[#22c55e]" />
                                <p className="-mt-3">Pass - {passCount}</p>
                              </div>
                              <div className="flex items-center gap-2">
                                <div className="w-3 h-3 rounded-full bg-[#ef4444]" />
                                <p className="-mt-3">Fail - {failCount}</p>
                              </div>
                              <div className="flex items-center gap-2">
                                <div className="w-3 h-3 rounded-full bg-[#9ca3af]" />
                                <p className="-mt-3">Error - {errorCount}</p>
                              </div>
                            </div>
                          </div>
                          
                        </div>
      
                        {/* Right Section - Subcategory List */}
                        <div className="w-[40%] border-l border-[#3c3c3c] p-4">
                          <p className="text-xl font-bold -mt-4">Methods</p>
                          <ul className="text-sm space-y-2 mt-4">
                            {Object.entries(subCategories).map(([subName, subVal], idx) => {                              
                              if (subVal.Fail > 0) {
                                return (
                                  <li key={idx} className="flex justify-between items-center">
                                    <span className="text-sm">{subName}</span>
                                    <span className="bg-[#ef4444] h-5 text-white text-center mt-4 text-sm px-4 py-1 rounded-full flex justify-center items-center">
                                      <p className="-mt-3">{subVal.Fail}</p>
                                    </span>
                                  </li>
                                );
                              }
                              return null;
                            })}
                          </ul>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className="m-12 flex flex-col page-break-start">
              <p className="text-3xl font-bold text-black ml-3 mb-4 m-4">Vulnerabilities</p>

              <div style={{ border: '1px solid #3c3c3c', borderBottom: '3px solid black', borderRadius: '0.75rem', overflow: 'hidden', backgroundColor: '#ffffff' }}>
                <Table sx={{ minWidth: 650 }} style={{ backgroundColor: '#ffffff' }}>
                  <TableHead style={{ backgroundColor: '#ffffff' }}>
                    <TableRow style={{ backgroundColor: '#ffffff' }}>
                      <TableCell><strong className="text-xl">Type</strong></TableCell>
                      <TableCell><strong className="text-xl">Description</strong></TableCell>
                      <TableCell><strong className="text-xl">Severity</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ backgroundColor: '#ffffff' }}>
                    {sortedVulnerabilities.map((issue, index) => (
                      <TableRow key={index} style={{ backgroundColor: '#ffffff' }}>
                        <TableCell>{issue.type}</TableCell>
                        <TableCell>{issue.description}</TableCell>
                        <TableCell>
                          <p className="h-10 flex justify-center items-center" style={{
                            backgroundColor: severityColors[issue.severity] || "transparent",
                            color: "white",
                            fontWeight: "bold",
                            textAlign: "center",
                            borderRadius: "0.5rem"
                          }}>
                            <span className="-mt-1">{issue.severity.charAt(0).toUpperCase() + issue.severity.slice(1).toLowerCase()}</span>
                          </p>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>

            </div>
            <p className="text-3xl font-bold text-black ml-1 mb-4 m-4">Prompts</p>
            {[...vulndata].sort((a, b) => {
              const severityOrder = {
                'critical': 1,
                'high': 2,
                'medium': 3,
                'low': 4
              };
              const aScore = a.score ? String(a.score).toLowerCase() : '';
              const bScore = b.score ? String(b.score).toLowerCase() : '';
              return (severityOrder[aScore] || 5) - (severityOrder[bScore] || 5);
            }).map((row, idx) => (
              <div key={idx} className="pdf-row-block">
                <table className="pdf-table">
                  <thead>
                    <tr>
                      <th className="col-category">Category</th>
                      <td className="col-other">{renderValue(row.category)}</td>
                      <th className="col-type">Type</th>
                      <td className="col-other">{renderValue(row.type)}</td>
                      <th className="col-severity">Severity</th>
                      <td className="col-severity">{renderValue(row.score)}</td>
                    </tr>
                  </thead>
                </table>

                <table className="pdf-table">
                  <tbody>
                    <tr>
                      <th className="col-category">Prompt</th>
                      <td colSpan="5">{renderValue(row.prompt)}</td>
                    </tr>
                    <tr>
                      <th className="col-category">Response</th>
                      <td colSpan="5">{renderValue(row.response)}</td>
                    </tr>
                    <tr>
                      <th className="col-category">Evaluation</th>
                      <td colSpan="5">{renderValue(row.error)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ))}
            

        </div> 
            
      </div>

      {sidebarOpen && (
        <div
          className="fixed right-0 top-0 h-full w-72 bg-white shadow-xl transition-transform duration-300 ease-in-out"
        >
          <div className="flex justify-between items-center p-4 border-b">
            <h2 className="text-xl font-bold">Sidebar</h2>
            <button onClick={toggleSidebar}>
              <X className="w-6 h-6" />
            </button>
          </div>

          <div className="p-4">{/* Sidebar Content Goes Here */}</div>
        </div>
      )}
    </div>
  );
}
